/**
 * React Query key factory for billing-related queries.
 *
 * Mirrors `src/lib/admin/adminKeys.ts`: centralised, composable, type-safe.
 * Per `.claude/rules/react-patterns.md`: every module MUST define a
 * centralised key factory; tests verify these keys are stable.
 */

export const billingKeys = {
  all: ['billing'] as const,
  summary: () => [...billingKeys.all, 'summary'] as const,
  events: (limit: number) => [...billingKeys.all, 'events', limit] as const,
  userPayments: (userId: string) =>
    [...billingKeys.all, 'user-payments', userId] as const,
}
